import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import { PartialRouteObject } from "react-router";

import SidebarLayout from "src/layouts/SidebarLayout";
import BaseLayout from "src/layouts/BaseLayout";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
	(
		<Suspense fallback={<SuspenseLoader />}>
			<Component {...props} />
		</Suspense>
	);

// Pages ForgetPassword
const Auth = Loader(lazy(() => import("src/screens/auth")));
const Registration = Loader(
	lazy(() => import("src/screens/auth/Registration"))
);
const ForgetPassword = Loader(
	lazy(() => import("src/screens/auth/ForgetPassword"))
);

const ResetPassword = Loader(
	lazy(() => import("src/screens/auth/ResetPassword"))
);

const Data = Loader(lazy(() => import("src/screens/pages/Data")));
const UserApp = Loader(lazy(() => import("src/screens/pages/UserApp")));
const UserLog = Loader(lazy(() => import("src/screens/pages/UserLog")));
const DataSheet = Loader(lazy(() => import("src/screens/pages/DataSheet")));
const Worksheet = Loader(lazy(() => import("src/screens/pages/Worksheet")));
const Worksheet1 = Loader(lazy(() => import("src/screens/pages/Worksheet1")));
const Worksheet2 = Loader(lazy(() => import("src/screens/pages/Worksheet2")));
const Worksheet3 = Loader(lazy(() => import("src/screens/pages/Worksheet3")));
const Worksheet4 = Loader(lazy(() => import("src/screens/pages/Worksheet4")));
const Worksheet5 = Loader(lazy(() => import("src/screens/pages/Worksheet5")));
const Logout = Loader(lazy(() => import("src/screens/auth/Logout")));

// Dashboards
const Crypto = Loader(lazy(() => import("src/screens/dashboards/Crypto")));

// Status
const Status404 = Loader(
	lazy(() => import("src/screens/pages/Status/Status404"))
);
const Status500 = Loader(
	lazy(() => import("src/screens/pages/Status/Status500"))
);
const StatusComingSoon = Loader(
	lazy(() => import("src/screens/pages/Status/ComingSoon"))
);
const StatusMaintenance = Loader(
	lazy(() => import("src/screens/pages/Status/Maintenance"))
);

const routes: PartialRouteObject[] = [
	{
		path: "*",
		element: <SidebarLayout />,
		children: [
			{
				path: "/",
				element: <Crypto />,
			},
			{
				path: "/profile",
				element: <Registration />,
			},
			{
				path: "/pwdforget",
				element: <ForgetPassword />,
			},
			{
				path: "/app",
				element: <UserApp />,
			},
			{
				path: "/log",
				element: <UserLog />,
			},
			{
				path: "/data",
				element: <Data />,
			},
			{
				path: "/datasheet",
				element: <DataSheet />,
			},
			{
				path: "/worksheet",
				element: <Worksheet />,
			},
			{
				path: "/tdsworksheet",
				element: <Worksheet1 />,
			},
			{
				path: "/intworksheet",
				element: <Worksheet2 />,
			},
			{
				path: "/intworksheetfull",
				element: <Worksheet3 />,
			},
			{
				path: "/intworksheetdet",
				element: <Worksheet4 />,
			},
			{
				path: "/worksheet5",
				element: <Worksheet5 />,
			},
			{
				path: "/logout",
				element: <Logout />,
			},
			{
				path: "status",
				children: [
					{
						path: "/",
						element: <Navigate to="404" replace />,
					},
					{
						path: "404",
						element: <Status404 />,
					},
					{
						path: "500",
						element: <Status500 />,
					},
					{
						path: "maintenance",
						element: <StatusMaintenance />,
					},
					{
						path: "coming-soon",
						element: <StatusComingSoon />,
					},
				],
			},
			{
				path: "/pwdforget",
				element: <ResetPassword />,
			},
			{
				path: "*",
				element: <Auth />,
			},
		],
	},
	{
		path: "dashboards",
		element: <SidebarLayout />,
		children: [
			{
				path: "/",
				element: <Navigate to="/" replace />,
			},
			{
				path: "crypto",
				element: <Crypto />,
			},
		],
	},
	{
		path: "/pwdforget",
		element: <ResetPassword />,
	},
	{
		path: "components",
		element: <SidebarLayout />,
	},
];

const authroutes: PartialRouteObject[] = [
	{
		path: "",
		element: <BaseLayout />,
		children: [
			{
				path: "/",
				element: <Auth />,
			},
			{
				path: "/pwdforget",
				element: <ForgetPassword />,
			},
			{
				path: "/register",
				element: <Registration />,
			},
			{
				path: "authentication",
				element: <Navigate to="/" replace />,
			},
			{
				path: "status",
				children: [
					{
						path: "/",
						element: <Navigate to="404" replace />,
					},
					{
						path: "404",
						element: <Status404 />,
					},
					{
						path: "500",
						element: <Status500 />,
					},
					{
						path: "maintenance",
						element: <StatusMaintenance />,
					},
					{
						path: "coming-soon",
						element: <StatusComingSoon />,
					},
				],
			},
			{
				path: "/pwdforget",
				element: <ForgetPassword />,
			},
		],
	},
	{
		path: "*",
		element: <Auth />,
	},
];

export default routes;
export { authroutes };
